<div id="content">
	<div id="main">
		<router-outlet></router-outlet>
	</div>
</div>
<bb-publication-menu id="sidebar"></bb-publication-menu>
